export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/1376265d92690fd518e46d698aec8208.png";